import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "videoPlayer",
    "playPauseButtonImage",
    "centralPlayPauseButton",
    "centralPlayPauseButtonImage",
    "muteButtonImage",
    "progressBar"
  ]

  static values = {
    playIcon: String,
    pauseIcon: String,
    translucentPlayIcon: String,
    translucentPauseIcon: String,
    muteIcon: String,
    unmuteIcon: String,
    nextUrl: String,
    previousUrl: String
  }

  connect() {
    if (!this.hasVideoPlayerTarget) return

    this.updatePlayButton()
    this.updateMuteButtonImage()
  }

  disconnect() {
    clearTimeout(this.centralPlayPauseButtonImageTimeout)
  }

  close(event) {
    event?.preventDefault()

    this.stopVideo()
    this.element.remove()
  }

  playNext(event) {
    event?.preventDefault()

    const url = event?.currentTarget?.dataset?.url || this.nextUrlValue
    if (!url) return

    this.stopVideo()
    this.navigate(url)
  }

  playPrevious(event) {
    event?.preventDefault()

    const url = event?.currentTarget?.dataset?.url || this.previousUrlValue
    if (!url) return

    this.stopVideo()
    this.navigate(url)
  }

  seek(event) {
    if (!this.videoPlayerTarget.duration) return

    const rect = event.currentTarget.getBoundingClientRect()
    const clickPosition = event.clientX - rect.left
    const percent = clickPosition / rect.width

    this.videoPlayerTarget.currentTime = percent * this.videoPlayerTarget.duration
  }

  mute() {
    this.videoPlayerTarget.muted = !this.videoPlayerTarget.muted
  }

  play() {
    if (this.videoPlayerTarget.paused) {
      this.videoPlayerTarget.play().catch(() => {})
    } else {
      this.videoPlayerTarget.pause()
    }
  }

  updateMuteButtonImage() {
    this.muteButtonImageTarget.src = this.videoPlayerTarget.muted
      ? this.muteIconValue
      : this.unmuteIconValue
  }

  updatePlayButton() {
    this.playPauseButtonImageTarget.src = this.videoPlayerTarget.paused
      ? this.playIconValue
      : this.pauseIconValue

    this.centralPlayPauseButtonImageTarget.src = this.videoPlayerTarget.paused
      ? this.translucentPlayIconValue
      : this.translucentPauseIconValue

    this.showCentralPlayPauseButtonImage()
  }

  showCentralPlayPauseButtonImage() {
    if (!this.hasCentralPlayPauseButtonTarget) return

    clearTimeout(this.centralPlayPauseButtonImageTimeout)

    this.centralPlayPauseButtonTarget.classList.add("is-visible")

    this.centralPlayPauseButtonImageTimeout = setTimeout(() => {
      this.centralPlayPauseButtonTarget.classList.remove("is-visible")
    }, 2000)
  }

  stopVideo() {
    this.videoPlayerTarget.pause()
    this.videoPlayerTarget.currentTime = 0
    this.videoPlayerTarget.removeAttribute("src")
    this.videoPlayerTarget.load()
  }

  navigate(url) {
    Turbo.visit(url, {
      frame: "snippets_player"
    })
  }

  updateProgress() {
    if (!this.videoPlayerTarget.duration || !this.hasProgressBarTarget) return

    const percent = (this.videoPlayerTarget.currentTime / this.videoPlayerTarget.duration) * 100

    this.progressBarTarget.style.width = `${percent}%`
  }
}
